/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuppliersDto as DigiworkMaitreDPosDtoSuppliersSuppliersDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Suppliers/suppliers-dto';

export interface GetAllSuppliers$Params {
  searchTerm?: string;
  isRemoved?: boolean;
}

export function getAllSuppliers(http: HttpClient, rootUrl: string, params?: GetAllSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSuppliersDto>> {
  const rb = new RequestBuilder(rootUrl, getAllSuppliers.PATH, 'get');
  if (params) {
    rb.query('searchTerm', params.searchTerm, {});
    rb.query('isRemoved', params.isRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSuppliersDto>;
    })
  );
}

getAllSuppliers.PATH = '/api/suppliers';
